import { DelimitedTextFile,  Account } from "./model";

declare global {
    interface Window { kj: any; }
}

function init() {
    window.kj = {
        DelimitedTextFile,
        Account,
    };
}

export { init };